var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "759px",
    height: "810px",
    viewBox: "0 0 759 810",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Organized Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Organized-Copy-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.178501674
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215,458 C205.545345,454.537319 198.081682,443.174551 198,431.668383 L198,333.93414 C198.081682,323.319464 204.503904,316 212.957958,316 C213.631832,316 214.305706,316.045126 215,316.138387 L215,316 C215.59,316.079939 216.19,316.19685 216.79,316.350733 L462.56,378.942103 C472.7,381.526136 481,393.671894 481,405.931564 L481,502.91776 C481,513.611622 474.69,521 466.34,521 C465.12,521 463.85,520.84212 462.56,520.511372 L216.79,457.919003 C216.19,457.76512 215.59,457.577263 215,457.35743 L215,458 Z",
    id: "Path",
    fill: "#0C3192"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileShadow);
export default __webpack_public_path__ + "static/media/ProfileShadow.139c484cd199c3a17cfff95a6bae0bd2.svg";
export { ForwardRef as ReactComponent };